/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Field_Select_OrganizationInputs */



/**
* | output |
* | --- |
* | "Select Organization" |
*
* @param {Form_Field_Select_OrganizationInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const form_field_select_organization = /** @type {((inputs?: Form_Field_Select_OrganizationInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Field_Select_OrganizationInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Organisation auswählen")
	return /** @type {LocalizedString} */ ("Select Organization")
});